
<template>
  <cec-select-search
    v-model="internalValue"
    :options="options"
    :state="state"
    :disabled="disabled || loading"
    :placeholder="placeholder"
    v-bind="$attrs"
  />
</template>

<script>
import CecSelectSearch from './CecSelectSearch.vue';
import axios from 'axios';

export default {
  name: 'BancoDropDown',
  components: { CecSelectSearch },
  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number, null],
      default: null
    },
    state: {
      type: [Boolean, null],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Pesquise pelo nome ou código...'
    },
  },

  data: function () {
    return {
      internalValue: this.value,
      options: [],
      loading: false
    };
  },

  watch: {
    value: function (newVal) {
      this.internalValue = newVal;
    },
    internalValue: function (newVal) {
      this.$emit('input', newVal);
      this.$emit('change', newVal);
    }
  },

  created: function () {
    this.fetchRegistros();
  },

  methods: {
    fetchRegistros: function () {
      var self = this;
      this.loading = true;

      axios
        .get('/api/protected/banco/getAtivos')
        .then(function (response) {
          var data = response.data || [];

          self.options = data.map(function (item) {
            return {
              value: item.ID,
              text: item.CODIGONOME
            };
          });
        })
        .catch(function (error) {
          console.error('Erro ao buscar bancos', error);
        })
        .finally(function () {
          self.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/componentes/dropdown/BancoDropDown.vue